<template>
  <v-row justify="center">
    <v-dialog v-model="modalFormAlterPassword" persistent max-width="400px">
      <v-card>
        <v-toolbar color="tertiary" flat>
          <v-toolbar-title class="text-h6">{{ formTitle }}</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                      id="password"
                      label="Senha *"
                      name="password"
                      v-model="formData.password"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      outlined
                      :error-messages="errors.password"
                      :rules="rules.password"
                      dense
                    />
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-text-field
                      id="password_confirmation"
                      label="Repetir Senha *"
                      name="password_confirmation"
                      v-model="formData.password_confirmation"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      @click:append="showPassword = !showPassword"
                      outlined
                      :error-messages="errors.password_confirmation"
                      :rules="rules.password_confirmation"
                      dense
                    />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="red" dark
                   depressed
                   @click="toggleFormPassord">
              <v-icon small left>mdi-close</v-icon>
              Fechar
            </v-btn>
            <v-btn
              :disabled="!valid"
              depressed
              :loading="isloadingSubmit"
              color="green" dark
              type="submit">
              <v-icon small left>mdi-send</v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { min, required } from '@/services/util/validate';
import toastMessage from '@/services/util/alertService';

export default {
  name: 'AuthPassordModalForm',
  data: () => ({
    showPassword: false,
    formTitle: 'Alteração de Senha',
    valid: true,
    formData: {
      id: '',
      password: '',
      password_confirmation: '',
    },
    formDataDefault: {
      id: '',
      password: '',
      password_confirmation: '',
    },
    rules: {
      password: [
        required,
        (value) => min(value, 6),
      ],
      password_confirmation: [
        required,
        (value) => min(value, 6),
      ],
    },
    errors: {
      password: [],
      password_confirmation: [],
    },
    isloadingSubmit: false,
  }),
  computed: {
    ...mapState('auth', ['authUser', 'modalFormAlterPassword']),
  },
  methods: {
    ...mapActions('auth', [
      'updatePassword', 'toggleFormPassord',
    ]),
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        this.updatePassword(this.formData).then(() => {
          toastMessage.successSave('Senha alterada com sucesso.');
          this.resetValidation();
        })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors)
                .forEach(([index, value]) => {
                  this.errors[index].push(value.toString());
                  toastMessage.errorValidation();
                });
            } else {
              toastMessage.errorSave('Erro ao alter senha');
            }
          })
          .then(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    openDialogForm() {
      this.resetValidation();
      this.formData.id = this.authUser.id;
      this.formData.password = '';
      this.formData.password_confirmation = '';
    },
    closeDialogForm() {
      setTimeout(() => {
        this.formData.id = this.authUser.id;
        this.formData.password = '';
        this.formData.password_confirmation = '';
        this.resetValidation();
      }, 300);
    },
  },
  watch: {
    modalFormAlterPassword(value) {
      if (value) {
        this.openDialogForm();
      } else {
        this.closeDialogForm();
      }
    },
    'formData.password': function () {
      this.errors.password = [];
    },
    'formData.password_confirmation': function () {
      this.errors.password_confirmation = [];
    },
  },
};
</script>

<style></style>
